export const PublicRoutes ={
    AUTH: '/' ,
    LOGIN: 'login' 
}
export const RoutesPrivate={
    RECURSOS: '/recursos',


}